import Cookies from 'universal-cookie';

/**
  * Returns the content for meta tag
  */
 export default function getMeta(name) {
  const tag = document.querySelector(`meta[name="${name}"], meta[property="${name}"]`);

  // We're falling back to Cookies here just in case
  return (tag && tag.content) || (new Cookies()).get(name) || '';
}
